document.addEventListener('DOMContentLoaded', function() {
    const progressFill = document.getElementById('progress-fill');
    const progressMarker = document.getElementById('progress-marker');
    const currentPoints = parseFloat(document.getElementById('current-points').textContent);
    const nextTierPoints = parseFloat(progressFill.getAttribute('data-next-tier-points')); // Get actual points to the next tier

    if (progressFill && progressMarker) {
        // Calculate the correct progress percentage
        const progressPercentage = (currentPoints / nextTierPoints) * 100;

        // Ensure the marker doesn't go beyond 100%
        const markerPosition = Math.min(progressPercentage, 100);
        progressMarker.style.left = markerPosition + '%';
        progressFill.style.width = markerPosition + '%';

        // Log values for debugging
        console.log(`Current Points: ${currentPoints}`);
        console.log(`Next Tier Points: ${nextTierPoints}`);
        console.log(`Progress Percentage: ${progressPercentage}%`);
    }
});
